(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.nv-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nv-visible'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('nv-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { io.observe(el); });

    // Red de seguridad: si por lo que sea el observer no dispara (pestaña en
    // segundo plano, vista incrustada), muestra todo tras un tiempo prudente.
    setTimeout(function () {
      document.querySelectorAll('.nv-reveal:not(.nv-visible)').forEach(function (el) {
        el.classList.add('nv-visible');
      });
    }, 4000);
  }

  function initCifras() {
    var nums = document.querySelectorAll('.nv-cifras__num[data-target]');
    if (!nums.length) return;
    var animated = false;
    function run() {
      if (animated) return;
      animated = true;
      nums.forEach(function (el) {
        var target = parseFloat(el.getAttribute('data-target')) || 0;
        var decimals = (el.getAttribute('data-target').split('.')[1] || '').length;
        var suffixEl = el.querySelector('.nv-cifras__suffix');
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          var value = target * eased;
          el.childNodes[0].nodeValue = value.toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
          else el.childNodes[0].nodeValue = target.toFixed(decimals);
        }
        el.childNodes[0].nodeValue = (0).toFixed(decimals);
        requestAnimationFrame(step);
      });
      if (suffixReattach) suffixReattach();
    }
    var suffixReattach = function () {
      nums.forEach(function (el) {
        var suffix = el.querySelector('.nv-cifras__suffix');
        if (suffix && el.lastChild !== suffix) el.appendChild(suffix);
      });
    };
    var section = document.querySelector('.nv-cifras');
    if (!section || !('IntersectionObserver' in window)) { run(); return; }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { run(); io.disconnect(); }
        });
      },
      { threshold: 0.4 }
    );
    io.observe(section);
  }

  function initComparador() {
    document.querySelectorAll('[data-nv-comparador]').forEach(function (wrap) {
      var after = wrap.querySelector('.nv-comparador__after');
      var handle = wrap.querySelector('.nv-comparador__handle');
      var dragging = false;

      function setPos(pct) {
        pct = Math.max(0, Math.min(100, pct));
        wrap.style.setProperty('--nv-pos', pct + '%');
      }
      function posFromClientX(clientX) {
        var rect = wrap.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }
      wrap.addEventListener('pointerdown', function (e) {
        dragging = true;
        wrap.setPointerCapture(e.pointerId);
        setPos(posFromClientX(e.clientX));
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        setPos(posFromClientX(e.clientX));
      });
      ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
        wrap.addEventListener(evt, function () { dragging = false; });
      });
      handle.setAttribute('tabindex', '0');
      handle.setAttribute('role', 'slider');
      handle.setAttribute('aria-valuemin', '0');
      handle.setAttribute('aria-valuemax', '100');
      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(wrap.style.getPropertyValue('--nv-pos')) || 50;
        if (e.key === 'ArrowLeft') { setPos(current - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(current + 5); e.preventDefault(); }
      });
    });
  }

  function initFaq() {
    document.querySelectorAll('.nv-faq__item').forEach(function (item) {
      var btn = item.querySelector('.nv-faq__q');
      var panel = item.querySelector('.nv-faq__a');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        item.closest('.nv-faq__wrap').querySelectorAll('.nv-faq__item').forEach(function (other) {
          other.setAttribute('data-open', 'false');
          other.querySelector('.nv-faq__a').style.maxHeight = null;
          other.querySelector('.nv-faq__q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.setAttribute('data-open', 'true');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  }

  function initProducto() {
    var root = document.querySelector('[data-nv-producto]');
    if (!root) return;

    // Galería: miniatura -> imagen principal
    var mainImg = root.querySelector('[data-nv-gallery-main]');
    var thumbs = root.querySelectorAll('[data-nv-thumb]');
    var thumbsArr = Array.prototype.slice.call(thumbs);

    function selectThumb(thumb) {
      var full = thumb.getAttribute('data-full');
      var alt = thumb.getAttribute('data-alt') || '';
      if (mainImg && full) {
        mainImg.src = full;
        mainImg.alt = alt;
      }
      thumbsArr.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }

    thumbsArr.forEach(function (thumb) {
      thumb.addEventListener('click', function () { selectThumb(thumb); });
    });

    // Deslizar con el dedo/ratón sobre la foto principal para cambiar de imagen
    var galleryMain = root.querySelector('.nv-producto__gallery-main');
    if (galleryMain && thumbsArr.length > 1) {
      var swipeStartX = 0;
      var swipeStartY = 0;
      var swiping = false;
      galleryMain.addEventListener('pointerdown', function (e) {
        swiping = true;
        swipeStartX = e.clientX;
        swipeStartY = e.clientY;
      });
      galleryMain.addEventListener('pointerup', function (e) {
        if (!swiping) return;
        swiping = false;
        var dx = e.clientX - swipeStartX;
        var dy = e.clientY - swipeStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        var current = thumbsArr.findIndex(function (t) { return t.getAttribute('aria-current') === 'true'; });
        if (current === -1) current = 0;
        var next = dx < 0 ? current + 1 : current - 1;
        next = Math.max(0, Math.min(thumbsArr.length - 1, next));
        if (next !== current) selectThumb(thumbsArr[next]);
      });
      galleryMain.addEventListener('pointercancel', function () { swiping = false; });
    }

    // Variantes
    var variantsData = root.querySelector('[data-nv-variants]');
    var variants = variantsData ? JSON.parse(variantsData.textContent) : [];
    var pillGroups = root.querySelectorAll('[data-nv-option]');
    var idInput = root.querySelector('[data-nv-variant-id]');
    var priceEl = root.querySelector('[data-nv-price]');
    var compareEl = root.querySelector('[data-nv-compare]');
    var discountEl = root.querySelector('[data-nv-discount]');
    var addBtn = root.querySelector('[data-nv-add]');
    var stockEl = root.querySelector('[data-nv-stock]');
    var stockTextEl = root.querySelector('[data-nv-stock-text]');

    function selectedOptions() {
      var selected = [];
      pillGroups.forEach(function (group) {
        var active = group.querySelector('[aria-pressed="true"]');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }

    function findVariant() {
      var selected = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }

    function formatMoney(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
        style: 'currency',
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR',
      });
    }

    function updateFromVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (onSale) {
          compareEl.textContent = formatMoney(variant.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (discountEl) {
        if (onSale) {
          var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          discountEl.textContent = '-' + pct + '%';
          discountEl.hidden = false;
        } else {
          discountEl.hidden = true;
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available
          ? addBtn.getAttribute('data-label-add')
          : addBtn.getAttribute('data-label-soldout');
      }
      if (stockEl) {
        stockEl.setAttribute('data-state', variant.available ? 'in' : 'out');
        if (stockTextEl) stockTextEl.textContent = variant.available ? 'En stock' : 'Agotado';
      }
      if (variant.image && mainImg) {
        mainImg.src = variant.image;
        mainImg.alt = variant.image_alt || mainImg.alt;
        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', t.getAttribute('data-full') === variant.image ? 'true' : 'false');
        });
      }
    }

    pillGroups.forEach(function (group) {
      group.querySelectorAll('[data-nv-pill]').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('[data-nv-pill]').forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
          pill.setAttribute('aria-pressed', 'true');
          updateFromVariant();
        });
      });
    });

    if (variants.length) updateFromVariant();

    // Cantidad
    var qtyInput = root.querySelector('[data-nv-qty]');
    root.querySelectorAll('[data-nv-qty-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var delta = btn.getAttribute('data-nv-qty-btn') === 'plus' ? 1 : -1;
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + delta);
        qtyInput.value = next;
      });
    });
  }

  function initDrawerVisual() {
    document.querySelectorAll('[data-nv-360]').forEach(function (root) {
      var stage = root.querySelector('.nv-360__stage');
      var shadow = root.querySelector('[data-nv-360-shadow]');
      var frames = Array.prototype.slice.call(root.querySelectorAll('.nv-360__frame'));
      var total = frames.length;
      if (!stage || !total) return;

      var shadowBaseW = 0;
      var shadowCx = 0;
      var shadowCy = 0;
      function layoutShadow() {
        if (!shadow) return;
        var rootRect = root.getBoundingClientRect();
        var stageRect = stage.getBoundingClientRect();
        shadowBaseW = stageRect.width * 0.72;
        shadowCx = stageRect.left - rootRect.left + stageRect.width / 2;
        shadowCy = stageRect.bottom - rootRect.top - stageRect.height * 0.06;
        shadow.style.width = shadowBaseW + 'px';
      }

      function updateShadow(i) {
        if (!shadow) return;
        layoutShadow();
        if (!shadowBaseW) return;
        var angleRad = (i / total) * Math.PI * 2;
        var scale = 0.62 + 0.38 * Math.abs(Math.cos(angleRad));
        var x = shadowCx - (shadowBaseW * scale) / 2;
        var y = shadowCy - 10;
        shadow.style.transform = 'translate(' + x + 'px, ' + y + 'px) scaleX(' + scale.toFixed(3) + ')';
      }

      var current = 0;
      function relayout() { layoutShadow(); updateShadow(current); }
      relayout();
      window.addEventListener('resize', relayout);
      var detailsEl = root.closest('details');
      if (detailsEl) {
        detailsEl.addEventListener('toggle', function () {
          if (detailsEl.open) { requestAnimationFrame(relayout); }
        });
      }
      if ('ResizeObserver' in window) {
        new ResizeObserver(relayout).observe(stage);
      }
      function show(i) {
        i = ((i % total) + total) % total;
        if (i === current) return;
        frames[current].classList.remove('is-active');
        frames[i].classList.add('is-active');
        current = i;
        updateShadow(i);
      }

      var dragging = false;
      var startX = 0;
      var startFrame = 0;
      var pxPerFrame = 12;

      stage.addEventListener('pointerdown', function (e) {
        dragging = true;
        startX = e.clientX;
        startFrame = current;
        stage.setPointerCapture(e.pointerId);
      });
      stage.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        var delta = e.clientX - startX;
        show(startFrame + Math.round(delta / pxPerFrame));
      });
      function endDrag() {
        dragging = false;
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);
      stage.addEventListener('pointerleave', function () {
        if (dragging) endDrag();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCifras();
    initComparador();
    initFaq();
    initProducto();
    initDrawerVisual();
  });
})();
